// File: src/pages/recruiting/RecruitmentSurveySubmitted.jsx
import React from 'react';

export default function RecruitmentSurveySubmitted() {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: 16 }}>
      <div style={{ fontWeight: 900, fontSize: 22, color: '#111' }}>Survey submitted</div>
      <div style={{ marginTop: 8, color: '#6b7280', lineHeight: 1.45 }}>
        Thanks — we received your application. We’ll follow up with next steps.
      </div>

      <div style={{ marginTop: 14 }}>
        <a
          href="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 44,
            padding: '0 16px',
            borderRadius: 12,
            border: '1px solid #e5e7eb',
            background: '#111',
            color: '#fff',
            fontWeight: 900,
            textDecoration: 'none',
          }}
        >
          Back to app
        </a>
      </div>
    </div>
  );
}
